// extracted by mini-css-extract-plugin
export var dividerWrapper = "index-v2-module--dividerWrapper--f737e";
export var event = "index-v2-module--event--1f554";
export var eventCtaWrapper = "index-v2-module--eventCtaWrapper--1634d";
export var eventTime = "index-v2-module--eventTime--b8ffb";
export var eventTitle = "index-v2-module--eventTitle--6caae";
export var icon = "index-v2-module--icon--68d84";
export var innerWrapper = "index-v2-module--innerWrapper--63b64";
export var noEvents = "index-v2-module--noEvents--52ebc";
export var readMore = "index-v2-module--readMore--cea01";